import lowerCase from 'lodash/lowerCase';
import upperCase from 'lodash/upperCase';

export function compileLocalizedPlans({
  siteCountries = [],
  isJobRemote,
  jobCountryCode = 'EU',
  companyCountryCode = 'EU',
  isStandalone,
  allCampaigns,
  isLoggedIn,
  userCurrentProfile,
  initCompany,
  shouldFeaturesBeOpenByDefault = false
}) {
  const parseMonetisingOption = (plan) => {
    let allCountries = siteCountries;
    let currency = 'eur';
    let cost = '';
    let isRemote = isJobRemote;

    let setCostAndCurrency = (countryCode) => {
      // console.log('setCostAndCurrency', countryCode);
      const country = allCountries.find((el) => {
        return el.value === countryCode;
      });

      currency = lowerCase(country.currency);
      // console.log(
      //   'plan?.stripe?.price?.currency_options',
      //   currency,
      //   plan?.stripe?.price?.currency_options
      // );
      cost =
        plan?.stripe?.price?.currency_options[currency]?.unit_amount ||
        plan?.stripe?.price?.currency_options[currency]?.unit_amount_decimal;

      // console.log('cost', cost);
      if (!cost) {
        let currencies = Object.keys(plan?.stripe?.price?.currency_options || {});
        if (currencies[0]) {
          cost = plan?.stripe?.price?.currency_options[currencies[0]]?.unit_amount;
        }
      }
    };

    if (isRemote) setCostAndCurrency(companyCountryCode);
    else setCostAndCurrency(jobCountryCode);

    const parseCost = (rawCost) => {
      rawCost = rawCost.toString();

      let costIntegerPart = Math.trunc(rawCost / 100)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      let costFractionalPart = rawCost.substring(rawCost.length - 2);

      if (costFractionalPart == '00') {
        costFractionalPart = '-';
      }

      let result = `${costIntegerPart},${costFractionalPart}`;
      if (result === '0,0') {
        result = '0,-';
      }
      if (currency === 'eur') {
        return `€${costIntegerPart}`;
      } else {
        return `${result} ${upperCase(currency)}`;
      }
    };

    const parseFeatures = (edgeFeature) => {
      switch (edgeFeature) {
        case 'publishing':
          return ['publishing'];
        case 'promotion':
          return ['publishing', 'promotion'];
        case 'max':
          return ['publishing', 'promotion', 'max'];
        case 'headhunter':
          return ['publishing', 'promotion', 'max', 'headhunter'];
        default:
          return [];
      }
    };

    const parseOpenFeatures = (edgeFeature) => {
      switch (edgeFeature) {
        case 'publishing':
          return ['publishing'];
        case 'promotion':
          return [, 'promotion'];
        case 'max':
          return ['max'];
        case 'headhunter':
          return ['headhunter'];
        default:
          return [];
      }
    };

    const getOnClick = (name) => {
      switch (name) {
        case 'FREE':
          return () => {
            window.open(
              !(isLoggedIn && userCurrentProfile?.type === 'company')
                ? '/client/startups/new'
                : `/client/startups/${initCompany.key}/jobs/new`,
              '_blank'
            );
          };
        case 'BASIC':
          return () => {
            window.open(
              !(isLoggedIn && userCurrentProfile?.type === 'company')
                ? '/client/startups/new'
                : `/client/startups/${initCompany.key}/jobs/new`,
              '_blank'
            );
          };
        case 'PRO':
          return () => {
            window.open(
              !(isLoggedIn && userCurrentProfile?.type === 'company')
                ? '/client/startups/new'
                : `/client/startups/${initCompany.key}/jobs/new`,
              '_blank'
            );
          };
        case 'MAX':
          return () => {
            window.open(
              !(isLoggedIn && userCurrentProfile?.type === 'company')
                ? '/client/startups/new'
                : `/client/startups/${initCompany.key}/jobs/new`,
              '_blank'
            );
          };
        case 'SCOUT':
          return () => {
            window.open(
              !(isLoggedIn && userCurrentProfile?.type === 'company')
                ? '/client/startups/new'
                : `/client/startups/${initCompany.key}/jobs/new`,
              '_blank'
            );
          };
        default:
          return [];
      }
    };
    return {
      currency: upperCase(currency),
      id: plan.id,
      label: (plan.label || '').toUpperCase(),
      title: plan.name,
      isFree: plan.isFree,
      cost: parseCost(cost),
      discount: plan.discount,
      banner: plan.banner,
      target: plan.target,
      targetDescription: plan.mostPopular
        ? 'guaranteed <b>successful hire</b>'
        : plan.name?.toLowerCase() === 'free'
        ? undefined
        : plan.name?.toLowerCase() === 'basic'
        ? '<a class="link" href="https://thehub.io/community-program" target="_blank" style="color:#443fdb"> Apply for free job posting</a>'
        : 'more qualified <b>applicants</b>',
      features: parseFeatures(plan.featuresLevel),
      duration: plan.durationInDays ? plan.durationInDays / 7 + ' weeks' : 'Unlimited',
      isHighlighted: plan.mostPopular,
      isLiteHighlighted: plan.name.toLowerCase() === 'max',
      openFeatures: shouldFeaturesBeOpenByDefault ? parseOpenFeatures(plan.featuresLevel) : [],
      selectButtonText: plan.selectButtonText || 'Select',
      selectButtonAction: getOnClick(plan.name),
      exploreUrl: plan.exploreUrl,
      exploreLinkTitle: `Explore ${
        plan.label?.toLowerCase() === 'free' ? 'basic' : plan.label?.toLowerCase()
      }`
    };
  };
  return [
    ...allCampaigns.map(parseMonetisingOption).filter((item) => {
      return !(isStandalone && item.isFree);
    })
  ];
}

export function getFaqs({ activeProducts }) {
  return [
    {
      id: 2,
      question: `Is the Hub open to all?`,
      answer: `
        No. The Hub is the #1 recruitment platform for startups and scale-ups in the 
        Nordic region, exclusively accessible to growth companies from Denmark, Sweden, 
        Norway, Finland and Iceland. To be able to use The Hub’s job board you must 
        have a legally registered business entity in the Nordics and a functional 
        website. Furthermore, your business must be defined as a startup or a scale-up, 
        which per The Hub’s definition means that you typically need to meet at least 
        three of the following four requirements;
        <ul>
          <li>
            Your company was founded less than 20 years ago
          </li>
          <li>
            Your company intends to grow through the means of external investors
          </li>
          <li>
            Your company’s core business is scalable largely due to the application of 
            technology, not human capital
          </li>
          <li>
            Your company is innovative, challenging the status quo within its market
          </li>
        </ul>
        The Hub’s Customer Success team will carefully review all registered businesses 
        to ensure that they comply with our requirements. Corporates, recruitment agencies 
        and external headhunters are not allowed on the site. 
        `
    },
    {
      id: 3,
      question: `Why should I publish my jobs on The Hub?`,
      answer: `
      No other platform drives more startup-ready candidates per job post than The Hub, 
      regardless of category. On The Hub you can easily attract candidates within 
      Engineering, Data & Analytics, Sales & Marketing, Product & Design, Operations & 
      Finance, HR & Recruiting and more - both onsite and remote, full/part time or even 
      co-founders or interns.
      <br>
      Completely free of charge, all job posters get access to a powerful talent dashboard 
      with unlimited seats to manage and process an unlimited amount of applicants, 
      including a customizable applicant funnel, candidate reviews, note-taking, 
      automated rejections and more.
      <br>
      The Hub is already trusted by 14k+ Nordic growth companies and is the leading Nordic 
      startup job board with 2.2 million yearly website sessions. More than 55k job 
      applications are submitted to companies on The Hub each month and The Hub’s total 
      talent pool is comprised of 600k+ startup-ready candidates, ready to start their 
      next chapter at an inspiring and ambitious company.
      `
    },
    {
      id: 4,
      question: `How much does it cost me to post a job?`,
      answer: `
          The cost associated with job posting depends on the plan you select.
          <br>
          At only 699 DKK / 990 SEK/NOK / €89 per job, the <b>Basic</b> job post is a truly powerful 
          way to hire startup-ready candidates at the best market price.
          <br>
          <b>Pro</b> is priced at 2,490 DKK / 3,990 NOK/SEK / €330.
          <br>
          <b>Headhunter</b> is free (to get started), but you pay per successful hire (19,999 DKK / 
          29,990 NOK/SEK) / €2690).
        `
    },
    {
      id: 5,
      question: `Why should I choose the Basic job post?`,
      answer: `
        The Basic job post is The Hub’s most affordable job listing option, designed for early 
        stage startups looking to fill their position without breaking the bank. At only 
        699 DKK / 990 SEK/NOK / €89, the Basic job post is a truly powerful way to hire at 
        the best market price. 
        <br>
        All Basic job posts are live for up to 6 weeks and include the following features;
        <br>
        <b>The Hub Job Post 🚀</b>
        <br>
        Your job post will automatically appear in The Hub’s job search with 2.1 million 
        yearly website sessions, loved by more than 500k registered talents looking for their 
        dream job at a Nordic startup. All jobs are synced to your free company page which 
        serves as your career page within our community.
        <br>
        <b>LinkedIn & Google Job Post 🟦</b>
        <br>
        Your job is automatically posted on LinkedIn - the most popular job platform globally. 
        Your job can be found through the LinkedIn.com ‘Jobs’ tab, accessible to top talent 
        looking for Nordic startup jobs. Your job is also shared with Google’s Jobs Network, 
        displayed to millions of job seekers searching for jobs on Google.
        <br>
        <b>Partner Network Job Post 🌐</b>
        <br>
        Your job is automatically shared and posted on 100s of job boards in The Hub’s partner 
        network, including Jobindex, Jooble, Talent.com, Jobly, Platsbanken, Jobnet, 
        NAV Arbeidsplassen and many more.
        <br>
        <b>Email Job Alert 💌</b>
        <br>
        Your job is automatically emailed to up to 100k candidates, subscribed to be notified 
        about new opportunities like yours. 
      `
    },
    {
      id: 6,
      question: `Why should I choose the Pro job post?`,
      answer: `
          The Pro job post is The Hub’s mid-tier and incredibly cost-effective job listing option, 
          offering additional features and visibility compared to the Basic job post. Pro comes 
          with a powerful promotional bundle, tailored to startups that are eager to get more and 
          better candidates into the funnel. Pro typically drives 5-8x more views compared to the 
          Basic job post and drastically increases exposure to passive talent. 
          <br>
          Pro is priced at 2,490 DKK / 3,990 NOK/SEK / €330 and includes all the features from 
          Basic, plus the following;
          <br>
          <br>
          <b>Featured 📣</b>
          <br>
          Your job post will be featured on top of The Hub’s job search and email job alerts for 
          increased visibility throughout its duration. Your job post will get a unique coloured 
          frame and ribbon to make it stand out from normal jobs.  
          <br>
          <b>Organic LinkedIn Post 🟦</b>
          <br>
          With 45k+ followers and growing, The Hub’s LinkedIn page is a remarkable channel to 
          reach active and passive job seekers. Our marketing team will create a unique post 
          to promote your job to all our followers and encourage applications.  
      `
    },
    {
      id: 7,
      question: `Why should I choose the Max job post?`,
      answer: `
        The Max job post is The Hub’s most powerful listing option and is the only option that 
        offers hands-on support from a dedicated human (Recruitment Success Manager), a huge step 
        up from The Hub’s 
        <a
           href="https://www.notion.so/Basic-job-post-a0ca7519c2124c47b5721e45defabbea?pvs=21"
           target="_blank"
           class="text-blue-800"
         >
           Basic job post
        </a> 
        and the 
        <a
           href="https://www.notion.so/Pro-job-post-247ab45ff7444881a21b8899ba43d85d?pvs=21"
           target="_blank"
           class="text-blue-800"
         >
           Pro job post
        </a>.
        Max is designed for companies who want to take a proactive approach to recruitment and building 
        their talent pools without the cost of using a standard recruitment agency. With Max we can 
        guarantee that your role will reach the passive talent (the golden candidates who are open to 
        a move but aren't actively looking). The service is perfect for specialist or key roles or 
        roles that have been unsuccessful through advertising alone.
        <br>
        <br>
        Max is priced at 7,990 DKK / 12,990 NOK/SEK / €1100 and includes all the features from Basic and Pro, 
        plus the following;
        <br>
        <br>
        <b>Proactive search 🔍</b>
        <br>
        We will search out relevant profiles in The Hub’s 650k+ talent database that have been interviewed or 
        shortlisted for similar roles in the past and nudge them to apply for your job. Tackling your 
        recruitment from all sides, we will also reach out to candidates externally using our LinkedIn 
        Recruiter License, urging them to apply and promoting your business. 
        <br>
        <br>
        <b>Candidate screening 👁️</b>
        <br>
        We will manage and process all incoming applicants for you to save precious time that you should be 
        spending on core business activities. Unqualified candidates that do not meet the requirements will 
        be rejected in a professional manner. Relevant profiles will be presented to you with a 1-5 star 
        rating, and a short comment with our initial review, ready to interview.  Every candidate you see 
        from us is not only skill-matched to your job but is a warm lead already interested in joining your 
        business.
      `
    },
    {
      id: 9,
      question: `Why should I choose Scout?`,
      answer: `
        Scout is our most sophisticated recruitment service and is suited for companies that are seeking 
        support beyond a job post. Unlike the Max job post, which also offers hands-on support from a 
        dedicated recruiter, Scout comes with a guaranteed hire, meaning you don’t pay anything you 
        actually hire. You can learn more about our Scout service 
        <a
           href="https://www.notion.so/Add-Scout-FAQ-15a34d604eaa80569fefc6b7fdbb4a87?pvs=21"
           target="_blank"
           class="text-blue-800"
         >
           here
        </a>.
        <br>
        <br>
        Scout is a “no cure, no pay” service priced at 19,990 DKK / 29,990 NOK/SEK / €2600 per successful 
        hire, with no upfront payment.
      `
    },
    // {
    //   id: 7,
    //   question: `Why should I choose the Headhunter job post?`,
    //   answer: `
    //     The Headhunter job post is not just a job post - it unlocks a technical recruiter to
    //     work alongside you until a hire is made, with “no cure, no pay” terms. The Headhunter
    //     service is a unique & data-driven approach to headhunting designed specifically for
    //     startups and scale-ups.
    //     <br>
    //     The Headhunter job post includes everything in Pro (at no upfront cost) plus the
    //     following features;
    //     <br>
    //     <ul>
    //       <li>
    //         Once published, you will be assigned a dedicated Recruitment Success Manager (RSM)
    //         from our team of recruitment experts.
    //       </li>
    //       <li>
    //         Your RSM will book you for a quick call to learn how to pitch your business and the
    //         ideal profiles you are looking for.
    //       </li>
    //       <li>
    //         Your RSM will instantly start approaching relevant candidates in our 600k talent
    //         pool to increase applicant quantity and quality.
    //       </li>
    //       <li>
    //         Your RSM will search for and approach relevant candidates on LinkedIn.
    //       </li>
    //       <li>
    //         In addition to the promotions included in Pro, your RSM will also assign a LinkedIn
    //         Promoted Job Slot (at no cost).
    //       </li>
    //       <li>
    //         Your RSM will carefully screen out the best fits and reject unqualified candidates
    //         based on your criteria. Qualified and approved candidates are delivered to your
    //         inbox twice a week.
    //       </li>
    //       <li>
    //         If you don’t hire, you don’t pay. Your RSM will coordinate and send an invoice once
    //         a hire has been successfully made. The price per hire is 19,999 DKK / 29,990 NOK/SEK)
    //         / €2690. No hidden costs.
    //       </li>
    //       <li>
    //         Read the terms of use for the Headhunter job post <a
    //           href="https://thehub.io/scout-terms"
    //           target="_blank"
    //           class="text-blue-800"
    //         >
    //           here
    //         </a>.
    //       </li>
    //     </ul>
    //   `
    // },
    // {
    //   id: 8,
    //   question: `How do you guarantee a hire with the Headhunter job post?`,
    //   answer: `
    //     Once Headhunter has been selected, you do not pay anything unless you actually hire.
    //     We’ve put together a simple one-pager with
    //     <a
    //       href="https://thehub.io/headhunter-terms"
    //       target="_blank"
    //       class="text-blue-800"
    //     >
    //       terms and conditions
    //     </a>
    //     , covering all the various scenarios and events.
    //   `
    // },
    {
      id: 10,
      question: `We’re currently not recruiting, should we still have a profile?`,
      answer: `
        Yes. Candidates are constantly scouting The Hub to find the perfect company to work for.
        All companies on The Hub can be discovered based on markets, company stage/size, culture,
        location and more. If you want to be on their radar you’ll need a profile, and as soon as
        your hiring needs occur you’ll be ready to post jobs with just a few clicks.
      `
    },
    {
      id: 11,
      question: `We use an ATS. Can we still use The Hub?`,
      answer: `
        Yes. We currently support integrations with Teamtailor, Workable, Greenhouse and Lever.
        To connect your ATS, head over to ‘startup settings’ by clicking on your company logo in
        the top right corner when logged in to explore specific guides on each ATS. Once connected,
        you will be able to automatically post your active ATS jobs directly to The Hub. When jobs
        update in your ATS (e.g. expire or are edited) they will automatically update on The Hub as
        well. All applicants applying via The Hub will be directly forwarded to your careers site
        (ATS) so that you can manage all applicants in one place. Are you using an ATS that we
        currently don’t support? Send an email to
        <a
          href="mailto:info@thehub.io"
          target="_blank"
          class="text-blue-800"
        >
          info@thehub.io
        </a>
        and we’ll add it to our roadmap!
      `
    },
    {
      id: 12,
      question: `We use an ATS. How do we pay for jobs?`,
      answer: `
        Through invoicing. At the beginning of each new month, an invoice will be issued reflecting 
        usage (the number of jobs imported) in the previous month. There is no duration/cap on how 
        long each job can be published and you only pay once per job, the first time a new job is 
        published.
      `
    }
  ];
}

export function getFeatures() {
  return [
    {
      id: 'publishing',
      title: 'Basic',
      icon: '/monetise/publishing_icon.svg',
      points: [
        'Duration:',
        'Your job will appear in <b>search results</b>, reaching <b>550k+</b> talents and <b>130k+</b> monthly active users',
        'Instant <b>email job alert</b> to up to <b>100k</b> relevant candidates',
        'Distributed to 150+ <b>partner job boards</b>, including LinkedIn'
      ]
    },
    {
      id: 'promotion',
      title: 'Pro',
      icon: '/monetise/promotion_icon.svg',
      points: [
        'Marked as <b>featured</b> on top of search results and email job alerts for <b>5x more visibility</b>',
        'Promoted on The Hub’s LinkedIn page with <b>50k+ followers</b>'
      ]
    },
    {
      id: 'max',
      title: 'Max',
      icon: '/monetise/headhunter_icon.svg',
      points: [
        '<b>Proactive search by a dedicated recruiter</b> in The Hub’s 600k+ talent database and on LinkedIn',
        '<b>Candidate screening</b> including assessment of all applicants  and professional rejections for unqualified profiles to save your time',
        // '<b>Interview booking</b> and candidate communication',
        '<b>Shortlist</b> with vetted candidates, ready to interview, including the recruiters’ evaluation and impression of each profile'
        // '<b>Promoted Job Slot on LinkedIn</b> for 14 days'
      ]
    },
    {
      id: 'headhunter',
      title: 'Scout',
      icon: '/monetise/headhunter_icon.svg',
      points: [
        'A <b>dedicated Recruitment Success Manager</b> to conduct search in The Hub’s 550k+ talent database and on LinkedIn (with recruiter License), presenting you with the best profiles, ready-to-interview',
        'Continuous <b>candidate screening</b> including professional rejections of unqualified candidates and evaluation and presentation of relevant profiles'
      ]
    }
  ];
}
